import React from 'react';
import { spacing, borderRadius, badgeVariants } from './tokens';

/**
 * AdminStatusBadge
 * 
 * Standardized status badge component for admin pages.
 * 
 * @param {string} variant - Badge variant: 'success' | 'warn' | 'error' | 'info' | 'neutral'
 * @param {string} children - Badge text
 * @param {object} style - Additional styles
 */
export default function AdminStatusBadge({ variant, status, children, style = {} }) {
  // Support both 'variant' and 'status' props for backward compatibility
  const badgeType = variant || status || 'neutral';
  
  const classNameMap = {
    active: 'admin-status-badge admin-status-badge-active',
    inactive: 'admin-status-badge admin-status-badge-inactive',
    success: 'admin-status-badge admin-status-badge-active',
    error: 'admin-status-badge admin-status-badge-inactive',
    warning: 'admin-status-badge admin-status-badge-warning',
    warn: 'admin-status-badge admin-status-badge-warning',
    info: 'admin-status-badge admin-status-badge-info',
    neutral: 'admin-status-badge',
  };
  
  const className = classNameMap[badgeType] || 'admin-status-badge';

  return (
    <span className={className} style={style}>
      {children}
    </span>
  );
}

// Styles removed - now using CSS classes from admin-ui.css

